import { useMemo } from 'react';
import { useWebview } from './webview';

export type Bridge =
  | { status: 'webview:present'; postMessage<T>(data: T): void }
  | { status: 'webview:missing' };

/**
 * Returns an explicit status of the webview, and a postMessage that
 * will safely encode and post the given data
 */
export function useBridge(): Bridge {
  const webview = useWebview();

  // TODO: is there a reason for a "webview:loading" status?
  return useMemo(() => {
    return webview == null
      ? { status: 'webview:missing' }
      : {
          status: 'webview:present',
          // TODO: require record with "type" property
          postMessage<T>(data: T) {
            // only accept an object message
            if (String(data) !== '[object Object]') return;

            try {
              webview?.postMessage?.(JSON.stringify(data));
            } catch (e) {
              console.error('Failed to postMessage to webview:', data);
            }
          },
        };
  }, [webview]);
}
